import axios from "axios";
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faTriangleExclamation,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

const FormModal = ({ setShowFormModal, tickets, eventName, eventId }) => {
  const [formData, setFormData] = useState({});
  const [currentStep, setCurrentStep] = useState(-1);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [inputFiles, setInputFiles] = useState({});
  const [savedData, setSavedData] = useState();
  const [errors, setErrors] = useState();
  const [couponInput, setCouponInput] = useState("");
  const [couponMessage, setCouponMessage] = useState("");
  const [coupons, setCoupons] = useState([
    {
      code: "AMBHOS200",
      // any one optional either discount or discountPercentage
      discount: "200",
      discountPercentage: "",
      forEvent: "Shaheed Run 3.0 - Doon Valley Half Marathon", //optional
    },
    {
      code: "AMBHOS500",
      discount: "500",
      discountPercentage: "",
      forEvent: "",
    },
    {
      code: "AMBHOS5P",
      discount: "",
      discountPercentage: "5",
      forEvent: "",
    },
    {
      code: "AMBHOS2P",
      // any one optional either discount or discountPercentage
      discount: "",
      discountPercentage: "3",
      forEvent: "Shaheed Run 3.0 - Doon Valley Half Marathon", //optional
    },
  ]);
  const fieldsPerStep = 5;

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    // For checkboxes, handle multiple selections
    if (type === "checkbox") {
      if (checked) {
        setFormData((prevData) => ({
          ...prevData,
          [name]: [...(prevData[name] || []), value],
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          [name]: prevData[name].filter((item) => item !== value),
        }));
      }
    } else if (type === "file") {
      setInputFiles((prevData) => ({
        ...prevData,
        [name]: files[0],
      }));
      // setFormData((prevData) => ({
      //   ...prevData,
      //   [name]: files[0],
      // }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // Updates couponDiscount if coupon is correct.
  const handleCoupon = () => {
    setCouponMessage("");
    let flag = 0;
    let discount = 0;
    const totalAmount = selectedTicket.price;

    coupons.map((coupon) => {
      if (
        coupon.code === couponInput &&
        coupon.forEvent &&
        coupon.forEvent === eventName
      ) {
        if (coupon.discount) {
          discount = parseInt(coupon.discount);
          flag = 1;
        } else if (coupon.discountPercentage) {
          discount = (totalAmount * parseInt(coupon.discountPercentage)) / 100;
          flag = 1;
        }
      } else if (
        coupon.code === couponInput &&
        (!coupon.forEvent || coupon.forEvent !== eventName)
      ) {
        flag = 0;
      }
    });

    if (flag == 1) {
      setSelectedTicket({
        ...selectedTicket,
        couponDiscount: discount,
      });
      setCouponMessage("Coupon Applied!");
    } else if (flag === 0) {
      setSelectedTicket({
        ...selectedTicket,
        couponDiscount: 0,
      });
      setCouponMessage("Coupon is invalid!");
    }
  };

  const handleTicketSelect = (ticket) => {
    setSelectedTicket({
      ...ticket,
      gst: parseInt((ticket.price * 18) / 100),
      platformFee: parseInt((ticket.price * 3) / 100),
    });
    setCurrentStep(0); // Move to the next step after selecting a ticket
  };

  const handleRequiredInputs = () => {
    const currentStepFields = selectedTicket.formFields.slice(
      currentStep * 5,
      (currentStep + 1) * 5
    );
    const errors = currentStepFields
      .filter((field) => !formData[field.question] && field.required === true)
      .map((field) => field.question);

    const fileErrors = currentStepFields
      .filter((field) => field.type === "file" && inputFiles[field.question])
      .map((field) => errors.pop(field.question));
    setErrors(errors);
    return errors;
  };

  const openModal = () => setShowFormModal(true);
  const closeModal = () => setShowFormModal(false);

  const handleNextStep = async () => {
    const err = await handleRequiredInputs();
    if (err.length === 0) {
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };

  const handlePrevStep = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };

  const startFieldIndex = currentStep * fieldsPerStep;
  const endFieldIndex = startFieldIndex + fieldsPerStep;

  const currentFields = selectedTicket?.formFields.slice(
    startFieldIndex,
    endFieldIndex
  );

  // Verifies payment and then saves all the data in sheetdb.
  const handleOrderCreation = async (razorpayInfo) => {
    try {
      const paymentVerificationResponse = await axios.post(
        `${process.env.REACT_APP_BACKEND_LINK}/paymentverification`,
        razorpayInfo
      );

      if (paymentVerificationResponse.data.success === true) {
        const inputFilesUrls = {};

        // Create an array of promises for uploading files
        const uploadPromises = Object.keys(inputFiles).map((key) => {
          const file = inputFiles[key];
          const formData = new FormData();
          formData.append("file", file);

          return axios
            .post(
              `${process.env.REACT_APP_BACKEND_LINK}/uploadfiles`,
              formData,
              {
                headers: { "Content-Type": "multipart/form-data" },
              }
            )
            .then((response) => {
              inputFilesUrls[key] = response.data;
            })
            .catch((error) => {
              console.error("Error uploading file:", error);
            });
        });

        // Wait for all file upload promises to complete
        await Promise.all(uploadPromises);

        const updatedData = {
          ...formData,
          ...inputFilesUrls,
          eventId: eventId,
          eventName: eventName,
          ticket: selectedTicket.name,
          ticketPrice: selectedTicket.price,
          couponDiscount: selectedTicket.couponDiscount
            ? selectedTicket.couponDiscount
            : "",
          GST18: selectedTicket.gst,
          platformFee3: selectedTicket.platformFee,
          AmountPaid: selectedTicket.couponDiscount
            ? parseInt(selectedTicket.price) +
              selectedTicket.gst +
              selectedTicket.platformFee -
              selectedTicket.couponDiscount
            : parseInt(selectedTicket.price) +
              selectedTicket.gst +
              selectedTicket.platformFee,
          RazorpayOrderId: razorpayInfo.razorpay_order_id,
          RazorpayPaymentId: razorpayInfo.razorpay_payment_id,
        };

        const saveEventUserResponse = await axios.post(
          `${process.env.REACT_APP_BACKEND_LINK}/saveeventuser`,
          updatedData
        );

        if (saveEventUserResponse.data.message === "Data Saved.") {
          setSavedData(razorpayInfo);
        }
      } else {
        console.log("Payment Verification failed");
      }
    } catch (error) {
      console.error("Error handling order creation:", error);
    }
  };

  const handlePayment = async () => {
    const err = await handleRequiredInputs();
    if (err.length > 0) {
      return;
    }
    const {
      data: { key },
    } = await axios.get(`${process.env.REACT_APP_BACKEND_LINK}/getkey`);

    const amount = selectedTicket.couponDiscount
      ? parseInt(selectedTicket.price) +
        selectedTicket.gst +
        selectedTicket.platformFee -
        selectedTicket.couponDiscount
      : parseInt(selectedTicket.price) +
        selectedTicket.gst +
        selectedTicket.platformFee;
    axios
      .post(`${process.env.REACT_APP_BACKEND_LINK}/checkout`, {
        amount,
      })
      .then((res) => {
        // console.log(res.data);
        const options = {
          key: key,
          amount: amount,
          currency: "INR",
          name: "Ambhos",
          description: "Order Payment",
          image:
            "https://ambhos-webapp-assets.s3.ap-south-1.amazonaws.com/ambhos_full_logo.png",
          order_id: res.data.order.id,
          handler: (response) => {
            handleOrderCreation(response);
          },
          prefill: {
            name: formData[`Full Name`],
            email: formData.Email,
            contact: formData[`Contact Number`],
          },
          notes: {
            address: "Razorpay Corporate Office",
          },
          theme: {
            color: "#e95911",
          },
        };
        const razor = new window.Razorpay(options);
        razor.open();
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="modal-overlay bg-black opacity-50 fixed inset-0"
        onClick={closeModal}
      />
      <div className="modal-container bg-white w-[900px] h-[800px] rounded-lg shadow-lg z-50">
        <div className="text-right mt-5 mr-10 text-lg">
          <FontAwesomeIcon
            icon={faXmark}
            className="cursor-pointer"
            onClick={closeModal}
          />
        </div>
        <div className="modal-content p-4 text-left md:mx-10 flex flex-col justify-between h-[700px] overflow-y-scroll">
          {savedData ? (
            <div className="h-full flex flex-col justify-center items-center">
              <FontAwesomeIcon
                icon={faCircleCheck}
                className="text-4xl text-green-600"
              />
              <p className="mt-3 mb-2 text-3xl">Payment Success!</p>
              <p className="mb-3 text-lg">
                Thanks for Registering for the event.
              </p>
              <hr className="border w-1/2 mb-3" />
              <p>
                <span className="font-semibold">Order Id: </span>
                {savedData.razorpay_order_id}
                mb-3
              </p>
              <p>
                <span className="font-semibold">Payment Id: </span>
                {savedData.razorpay_payment_id}
              </p>
              <p className="font-semibold mt-10">
                <FontAwesomeIcon
                  icon={faTriangleExclamation}
                  className="text-lg text-yellow-500 mr-3"
                />
                Take screenshot or note down these details for future reference.
              </p>
            </div>
          ) : (
            <>
              {currentStep === -1 && (
                <div>
                  <h2 className="text-2xl md:text-3xl font-semibold mb-3 md:mb-7">
                    Select a Ticket
                  </h2>
                  <hr className="border border-ambhosOrange mb-10" />
                  <div className="mb-4 space-y-7">
                    {tickets.map((ticket, index) => (
                      <>
                        <div
                          key={index}
                          className="mb-2 flex justify-between items-center md:mr-10"
                        >
                          <div className="w-32">
                            <p className="font-semibold">{ticket.name}</p>
                            <p className="leading-tight text-xs">
                              {ticket.description}
                            </p>
                          </div>
                          {ticket.mrp ? (
                            <div>
                              <p className="line-through text-xs">
                                ₹{ticket.mrp}
                              </p>
                              <div className="flex space-x-2 items-center">
                                <p className="font-semibold text-lg">
                                  ₹{ticket.price}
                                </p>
                                <p className="font-semibold text-sm text-ambhosOrange">
                                  {((ticket.mrp - ticket.price) / ticket.mrp) *
                                    100}
                                  % OFF
                                </p>
                              </div>
                            </div>
                          ) : (
                            <div>
                              <p className="font-semibold text-lg">
                                ₹{ticket.price}
                              </p>
                            </div>
                          )}
                          <div className="w-32 text-center">
                            {ticket.quantity > 0 ? (
                              <button
                                onClick={() => handleTicketSelect(ticket)}
                                className="bg-blue-500 hover:bg-blue-600 text-white rounded-lg px-4 py-2 h-10"
                              >
                                Book Now
                              </button>
                            ) : (
                              <p className="font-semibold text-red-600">
                                Sold Out
                              </p>
                            )}
                          </div>
                        </div>
                        <hr />
                      </>
                    ))}
                  </div>
                </div>
              )}
              {currentStep >= 0 && selectedTicket && (
                <>
                  <div>
                    <h2 className="text-3xl font-semibold mb-7">
                      Fill the details below - {currentStep + 1}
                    </h2>
                    <hr className="border border-ambhosOrange mb-7" />
                    {currentFields.map((field, index) => (
                      <div key={index} className="mb-4">
                        <label className="block font-semibold text-md mb-2">
                          {field.question}{" "}
                          {field.required === true && (
                            <span className="text-red-500"> *</span>
                          )}
                        </label>
                        {field.type === "radio" && (
                          <div>
                            {field.options.map((option, optionIndex) => (
                              <label key={optionIndex} className="block mb-2">
                                <input
                                  type="radio"
                                  name={field.question}
                                  value={option}
                                  checked={formData[field.question] === option} // Check if the current option is selected in state
                                  onChange={handleChange}
                                  className="mr-2"
                                />
                                {option}
                              </label>
                            ))}
                            {errors?.includes(field.question) && (
                              <small className="text-red-600">Required!</small>
                            )}
                          </div>
                        )}
                        {field.type === "checkbox" && (
                          <div>
                            {field.options.map((option, optionIndex) => (
                              <label key={optionIndex} className="block mb-2">
                                <input
                                  type="checkbox"
                                  name={field.question}
                                  value={option}
                                  checked={formData[field.question]?.includes(
                                    option
                                  )}
                                  onChange={handleChange}
                                  className="mr-2"
                                />
                                {option}
                              </label>
                            ))}
                            {errors?.includes(field.question) && (
                              <small className="text-red-600">Required!</small>
                            )}
                          </div>
                        )}
                        {field.type === "file" && (
                          <div>
                            <input
                              type="file"
                              name={field.question}
                              onChange={handleChange}
                              className="w-full border rounded-lg p-2"
                            />
                            {inputFiles[field.question] && (
                              <label>
                                Selected File:{" "}
                                <span className="font-semibold">
                                  {inputFiles[field.question].name}
                                </span>
                              </label>
                            )}
                            {errors?.includes(field.question) && (
                              <small className="text-red-600">Required!</small>
                            )}
                          </div>
                        )}
                        {field.type !== "radio" &&
                          field.type !== "checkbox" &&
                          field.type !== "file" && (
                            <div>
                              <input
                                type={field.type}
                                name={field.question}
                                value={formData[field.question] || ""}
                                onChange={handleChange}
                                className="w-full border rounded-lg p-2"
                              />
                              {errors?.includes(field.question) && (
                                <small className="text-red-600">
                                  Required!
                                </small>
                              )}
                            </div>
                          )}
                      </div>
                    ))}
                  </div>
                  <div className="flex flex-col items-end">
                    {currentStep ===
                      Math.ceil(
                        selectedTicket.formFields.length / fieldsPerStep
                      ) -
                        1 && (
                      <div className="mb-10 w-full md:w-1/2">
                        <div className="w-[305px] md:w-full border-2 border-gray-400 mt-5 p-2 rounded-md flex justify-between">
                          <input
                            type="text"
                            placeholder="Enter Coupon"
                            value={couponInput}
                            onChange={(e) => setCouponInput(e.target.value)}
                            className="outline-none"
                          />
                          <button
                            className="text-ambhosOrange active:scale-95"
                            onClick={handleCoupon}
                          >
                            Apply
                          </button>
                        </div>
                        {couponMessage && (
                          <small className="font-semibold text-ambhosOrange">
                            {couponMessage}
                          </small>
                        )}
                        <hr className="border border-gray-400 mt-5" />
                        <div>
                          <div className="flex justify-between my-3 px-2 font-semibold">
                            <p>{selectedTicket.name}</p>
                            <p>₹{selectedTicket.price}</p>
                          </div>
                          {(selectedTicket.couponDiscount ||
                            selectedTicket.couponDiscount > 0) && (
                            <div className="flex justify-between my-3 px-2 font-semibold">
                              <p>Coupon Discount</p>
                              <p>- ₹{selectedTicket.couponDiscount}</p>
                            </div>
                          )}
                          <div className="flex justify-between my-3 px-2 font-semibold">
                            <p>GST 18%</p>
                            <p>₹{selectedTicket.gst}</p>
                          </div>
                          <div className="flex justify-between my-3 px-2 font-semibold">
                            <p>Platform Fee 3%</p>
                            <p>₹{selectedTicket.platformFee}</p>
                          </div>
                          <hr className="border border-gray-400 mt-5" />
                          <div className="flex justify-between my-3 px-2 font-semibold">
                            <p>Net Payable</p>
                            <p>
                              ₹
                              {selectedTicket.couponDiscount
                                ? parseInt(selectedTicket.price) +
                                  selectedTicket.gst +
                                  selectedTicket.platformFee -
                                  selectedTicket.couponDiscount
                                : parseInt(selectedTicket.price) +
                                  selectedTicket.gst +
                                  selectedTicket.platformFee}
                            </p>
                          </div>
                        </div>
                        <hr className="border border-gray-400" />
                      </div>
                    )}
                    <div>
                      {currentStep > 0 && (
                        <button
                          onClick={handlePrevStep}
                          className="mr-2 bg-white w-32 text-ambhosOrange border border-ambhosOrange active:scale-95 rounded-lg px-4 py-2"
                        >
                          Previous
                        </button>
                      )}

                      {currentStep <
                        Math.ceil(
                          selectedTicket.formFields.length / fieldsPerStep
                        ) -
                          1 && (
                        <button
                          onClick={handleNextStep}
                          className="bg-ambhosOrange w-32 active:scale-95 text-white rounded-lg px-4 py-2"
                        >
                          Next
                        </button>
                      )}

                      {currentStep ===
                        Math.ceil(
                          selectedTicket.formFields.length / fieldsPerStep
                        ) -
                          1 && (
                        <button
                          onClick={handlePayment}
                          className="bg-ambhosOrange w-32 active:scale-95 text-white rounded-lg px-4 py-2"
                        >
                          Pay Now
                        </button>
                      )}
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormModal;
